import { Link } from 'react-router-dom';

const SearchTag = ({ label }) => {
  return label ? (
    <div className="ui container tags">
      <Link className="ui label" to={`/search?Subject=${label}`} key={label}>
        {label}
      </Link>
    </div>
  ) : (
    <span />
  );
};

export default SearchTag;
